import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import { Gateway, GatewayRequest, GatewayResponse } from './types'
import { GatewayWeight } from '../edit/types'

export const gatewaysListMounted = createEvent<GatewayRequest>()
export const syncPaymentsMethod = createEvent()
export const deleteGatewayEvent = createEvent<number>()

export const getGateways = fx<GatewayRequest, GatewayResponse>({
  method: 'GET',
  url: `/gateway`,
})

export const syncGateway = fx<void, void>({
  method: 'GET',
  url: `/gateway/get-praxis`,
})

export const deleteGateway = fx<GatewayWeight, GatewayWeight>({
  method: 'DELETE',
  url: '/gateway/',
})

export const $gateways = restore<Gateway[]>(
  getGateways.doneData.map((a) => a.body.items),
  [],
)
export const $totalCountOfGateways = restore(
  getGateways.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: gatewaysListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, searchedColumn, filters }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      const newFilters = {
        ...filters,
      }

      let newObj = Object.keys(newFilters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] = `${
            filters[key as keyof typeof filters]
          }`
        }

        return accumulator
      }, {} as any)

      if (searchText && searchedColumn) {
        newObj[searchedColumn] = searchText.toLowerCase()
      }

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    } else if (searchText && searchedColumn) {
      const searchObj: any = {}
      searchObj[searchedColumn] = searchText.toLowerCase()
      // @ts-ignore
      query['where'] = JSON.stringify(searchObj)
    }

    // @ts-ignore
    query['populate'] = JSON.stringify([
      'Gateway.withdrawalGroup',
      'Gateway.gatewayAccess',
      'Gateway.gatewayWeight',
      'Gateway.gatewayCommissions',
    ])
    return {
      query,
    }
  },
  target: getGateways,
})

sample({
  clock: syncPaymentsMethod,
  fn: () => ({}),
  target: syncGateway,
})

sample({
  clock: deleteGatewayEvent,
  fn: (id) => {
    return {
      url: `/gateway/${id}`,
    }
  },
  target: deleteGateway,
})

sample({ clock: deleteGateway.doneData, fn: () => ({}), target: getGateways })
